import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-no-internet',
  templateUrl: './no-internet.component.html',
  styleUrls: ['./no-internet.component.scss', './no-internet.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
 standalone: false
})
export class NoInternetComponent  {

  @Input() onlineStatusMessage: any;
  @Input() onlineStatus: any;

}
